var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSidebarCommunication(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.86116 5.85185C5.86116 4.69103 6.80219 3.75 7.96301 3.75H17.1482C18.309 3.75 19.2501 4.69103 19.2501 5.85185V17.1111C19.2501 18.2719 18.309 19.213 17.1482 19.213H7.96301C6.80219 19.213 5.86116 18.2719 5.86116 17.1111V5.85185Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50513 8.28956C8.50513 7.89906 8.82169 7.58249 9.2122 7.58249H15.8115C16.202 7.58249 16.5186 7.89906 16.5186 8.28956V8.28956C16.5186 8.68006 16.202 8.99663 15.8115 8.99663H9.2122C8.82169 8.99663 8.50513 8.68006 8.50513 8.28956V8.28956Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50513 11.5892C8.50513 11.1987 8.82169 10.8822 9.2122 10.8822H15.8115C16.202 10.8822 16.5186 11.1987 16.5186 11.5892V11.5892C16.5186 11.9797 16.202 12.2963 15.8115 12.2963H9.2122C8.82169 12.2963 8.50513 11.9797 8.50513 11.5892V11.5892Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.50513 14.8889C8.50513 14.4984 8.82169 14.1818 9.2122 14.1818H15.8115C16.202 14.1818 16.5186 14.4984 16.5186 14.8889V14.8889C16.5186 15.2794 16.202 15.596 15.8115 15.596H9.2122C8.82169 15.596 8.50513 15.2794 8.50513 14.8889V14.8889Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11116 11.2963H4.85185C3.27682 11.2963 2 12.5731 2 14.1481V17.1111C2 18.6861 3.27682 19.963 4.85185 19.963H7.95519C6.87259 19.9601 5.93183 19.3539 5.45129 18.463H4.85185C4.10524 18.463 3.5 17.8577 3.5 17.1111V14.1481C3.5 13.4015 4.10525 12.7963 4.85185 12.7963H5.11116V11.2963Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCommunication);
export default __webpack_public_path__ + "static/media/sidebar-communication.b7acaa7f.svg";
export { ForwardRef as ReactComponent };